export const skyScannerKey = "6e7d52ba08msh28f473b4450ca76p1a014cjsn53fa89ef7b79"
export const unsplashKey = "Client-ID XtksAc2TRoQPU-Pl_d1g03iFKpuNkTKaGKOPp72Vh6c"